import React from "react";
import { Button } from "antd";
import { PaperClipOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import CustomModal from "components/Common/CustomModal";

interface FilePreviewModalProps {
  visible: boolean;
  url: string | null;
  fileName?: string;
  onClose: () => void;
  width?: string | number;
}

const FilePreviewModal: React.FC<FilePreviewModalProps> = ({
  visible,
  url,
  fileName,
  onClose,
  width = "80%",
}) => {
  const { t } = useTranslation();

  if (!url) return null;

  const isImage = /\.(jpeg|jpg|gif|png|webp)$/i.test(url);
  const isPdf = /\.pdf$/i.test(url);

  const title = fileName || url.split("/").pop() || "";

  return (
    <CustomModal
      title={title}
      isOpen={visible}
      onClose={onClose}
      width={typeof width === "number" ? `${width}px` : width}
    >
      <div style={{ textAlign: "center", marginTop: 20 }}>
        {isImage ? (
          <img
            src={url}
            alt={title}
            style={{ maxWidth: "100%", maxHeight: "60vh" }}
          />
        ) : isPdf ? (
          <iframe
            src={url}
            title={title}
            style={{ width: "100%", height: "60vh", border: "none" }}
          />
        ) : (
          <div>
            <PaperClipOutlined style={{ fontSize: 48, color: "#999" }} />
            <p>{t("moduleFileUpload.previewNotAvailable")}</p>
            <Button
              type="primary"
              href={url}
              target="_blank"
              download={title}
            >
              {t("moduleFileUpload.downloadFile")}
            </Button>
          </div>
        )}
      </div>
    </CustomModal>
  );
};

export default FilePreviewModal;
